import { PageStructureFacade } from './page-structure/page-structure.facade';
import { BlocksFacade } from './blocks/blocks.facade';
import { SectionsFacade } from './sections/sections.facade';
import { ColumnsFacade } from './columns/columns.facade';
import { TabsFacade } from './tabs/tabs.facade';
import { GridsFacade } from '@web/store/page-structure/grids/grids.facade';
import { WidgetsFacade } from './widgets/widgets.facade';
import { WidgetsErrorsFacade } from './widgets-errors/widgets-errors.facade';

export const PageStructureFacades = [
    PageStructureFacade,
    BlocksFacade,
    SectionsFacade,
    ColumnsFacade,
    TabsFacade,
    GridsFacade,
    WidgetsFacade,
    WidgetsErrorsFacade,
];
